import { Box, Checkbox, HStack, Image, Pressable, Text } from 'native-base';
import React from 'react';
import { PaymentCard as PaymentCardType } from '../../__generated__/graphql';
import { capitalFirstLetter } from '../../Common/utils/string';

export function PaymentCard({
  card,
  savedCard,
  setSavedCard,
  disabled,
}: {
  card: PaymentCardType;
  savedCard: string | undefined;
  setSavedCard: (cardId: string) => void;
  disabled: boolean;
}) {
  const selected = savedCard === card?.id;
  const imageForCard = (card?: PaymentCardType | null | undefined) => {
    if (
      card?.cardType?.toLowerCase() === 'american express' ||
      card?.cardType?.toLowerCase() === 'amex'
    )
      return require('../../Assets/PaymentMethods/22.png');
    if (card?.cardType?.toLowerCase() === 'visa')
      return require('../../Assets/PaymentMethods/1.png');
    return require('../../Assets/PaymentMethods/2.png');
  };
  return (
    <Pressable
      onPress={() => {
        if (card?.id) {
          setSavedCard(card?.id);
        }
      }}
      disabled={disabled}
      opacity={disabled ? 0.5 : 1}
    >
      <HStack
        borderWidth={1}
        px={6}
        py={3}
        borderColor={'gray.200'}
        alignItems={'center'}
        p={2}
        space={2}
      >
        <Checkbox value={'checked'} isChecked={selected} />

        <Text fontWeight={selected ? 600 : null}>
          Saved Card - {capitalFirstLetter(card?.cardType ?? '')} {card?.cardLastFour}
        </Text>

        {/*<Box borderRadius={'sm'}>*/}
        {/*  <Image resizeMode={'contain'} source={imageForCard(card?.cardType)} w={12} h={6} />*/}
        {/*</Box>*/}
      </HStack>
    </Pressable>
  );
}
